import React, { useLayoutEffect, useState } from 'react';

import { useIsMobile } from '../../hooks';
import { useLocalize } from '../../localization';

export const getAgentConfig = () => {
  const agentId = process.env.REACT_APP_AGENT_ID;
  const authUrl = process.env.REACT_APP_AGENT_URL;
  const authToken = process.env.REACT_APP_AGENT_TOKEN;

  if (authUrl && authToken)
    return {
      agentId,
      authUrl,
      authToken,
    };

  return null;
};

const config = getAgentConfig();

type JessicaProps = {
  agentId?: string;
  language?: string;
  className?: string;
  enrollmentId?: string;
  callbacks?: any;
};

const Jessica: React.FC<JessicaProps> = ({
  agentId,
  className,
  callbacks = {},
  language: courseLanguage,
}) => {
  const [container, setContainer] = useState<any>();
  const { language: appLanguage } = useLocalize();
  const language = String(
    courseLanguage || appLanguage || ''
  ).toLocaleLowerCase();

  const isMobile = useIsMobile();
  const [inited, setInited] = useState(false);

  useLayoutEffect(
    () => {
      if (!config) return;

      const thisAgentId = agentId || config.agentId;
      if (!thisAgentId) return;

      if (!container) return;
      if (inited) return;
      if (!language) return;

      let ignore = false;
      const perform = async () => {
        const div = document.createElement('div');
        container.append(div);

        if (ignore) return;

        (window as any).AiAgentsWebWidget.init({
          initialState: {
            mic: true,
            speaker: true,
            collapsed: false,
          },

          loadLastConvertsation: true,

          container: !isMobile ? div : undefined,
          initialUserInputMode: 'textAndVoice',
          transcribeWidgetDesktopWidth: 320,
          transcribeWidgetDesktopHeight: 600,

          ...config,

          defaultComponentType: 'transcribe',

          zIndex: 20000,
          openButtonContainerMobileTop: 44,
          openButtonContainerMobileRight: 100,
          agentId: thisAgentId,
          overridenLanguage: language,
          // widgetTranscribeMode: !isMobile ? 'extended' : 'none',

          buttonsShowOnOff: {
            hideMenuExpandButton: true,
            hideMenuSwitchButton: false,
            hideMenuCloseButton: true,
          },

          callbacks: callbacks,
        });

        setInited(true);
      };

      perform();

      return () => {
        ignore = true;
        (window as any).AiAgentsWebWidget.destroy?.(true);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [container, language, agentId, isMobile]
  );

  return (
    <div
      id="temp-mount-id"
      className={className}
      ref={node => setContainer(node as any)}
    />
  );
};

export default React.memo(Jessica);
